import React from 'react'
import Loginform from '../components/Loginform'

const Login = () => {
    return (
        <div>
            <Loginform />
        </div>
    )
}

export default Login
